module.exports = __webpack_public_path__ + "static/media/plan-wom-250gb.2f4d9f5e.svg";